module.exports = __webpack_public_path__ + "static/img/Home.48c0fee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/storefront/Home.jpg
// module id = 9qs+
// module chunks = 1